module.exports = __webpack_public_path__ + "img/vessel_cape_sasanqua.ea3324a2.jpg";